export const comics = [
  {
    id: 1,
    slug: 'duzhe-yu-nvzhu',
    title: '读者与女主',
    author: '李惠',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20manhwa%20style%20romance%20illustration%20with%20a%20young%20man%20and%20woman%20facing%20each%20other%20on%20a%20university%20campus%20bench%2C%20soft%20cherry%20blossom%20petals%20falling%2C%20warm%20spring%20sunlight%2C%20soft%20color%20palette%2C%20clean%20lineart%2C%20webtoon%20cover%20art%20style&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    status: '连载中',
    rating: 9.5,
    views: 1280000,
    description: '普通大学生林小然偶然发现图书馆里的一本神秘日记，日记的主人竟然是校园里最受欢迎的学姐。一段穿越时空的浪漫故事就此展开，现实与幻想的界限逐渐模糊...',
    chapters: 87,
    updatedAt: '2026-07-02',
    featured: true,
  },
  {
    id: 2,
    slug: 'mofa-shaonu-de-qiyu',
    title: '魔法少女的奇遇',
    author: '金智秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20featuring%20a%20magical%20girl%20with%20flowing%20hair%20holding%20a%20glowing%20crystal%20staff%2C%20mystical%20forest%20background%20with%20floating%20sparkles%2C%20vibrant%20purple%20and%20gold%20color%20scheme%2C%20webtoon%20art%20style%2C%20clean%20lines&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '奇幻',
    status: '连载中',
    rating: 9.3,
    views: 965000,
    description: '平凡高中生苏菲某天发现自己拥有操控时间的能力，一个来自异世界的魔法使告诉她，她是拯救两个世界的唯一希望。惊险刺激的冒险旅程就此开启。',
    chapters: 64,
    updatedAt: '2026-07-01',
    featured: true,
  },
  {
    id: 3,
    slug: 'jianyu-wang',
    title: '剑域王',
    author: '朴正宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Action%20Korean%20manhwa%20cover%20with%20a%20powerful%20swordsman%20in%20dark%20armor%20standing%20on%20a%20cliff%20overlooking%20a%20ancient%20oriental%20city%2C%20dramatic%20sunset%20sky%2C%20epic%20atmosphere%2C%20webtoon%20style%20illustration%2C%20rich%20red%20and%20black%20tones&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '动作',
    status: '已完结',
    rating: 9.7,
    views: 2150000,
    description: '在剑术至高无上的世界中，少年剑客韩烈为了复兴没落的家族踏上修炼之路。历经无数生死考验，最终成为剑域最强的传说。',
    chapters: 156,
    updatedAt: '2026-06-15',
    featured: true,
  },
  {
    id: 4,
    slug: 'mi-shi-zhe',
    title: '迷失者',
    author: '崔敏雅',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20cover%20showing%20a%20silhouette%20figure%20walking%20through%20a%20foggy%20alley%20at%20night%2C%20dim%20streetlamp%20lighting%2C%20ominous%20mood%2C%20dark%20blue%20and%20gray%20color%20palette%2C%20webtoon%20art%20style&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '悬疑',
    status: '连载中',
    rating: 9.1,
    views: 780000,
    description: '侦探姜浩在一起失踪案中发现了隐藏在城市深处的惊天秘密，每一条线索都指向一个尘封二十年的旧案，真相远比想象的更加可怕。',
    chapters: 42,
    updatedAt: '2026-06-28',
    featured: false,
  },
  {
    id: 5,
    slug: 'richang-xiaojuchang',
    title: '日常小剧场',
    author: '安多恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20manhwa%20slice%20of%20life%20cover%20with%20a%20group%20of%20four%20friends%20laughing%20together%20in%20a%20cozy%20cafe%2C%20warm%20yellow%20lighting%2C%20casual%20outfits%2C%20cheerful%20atmosphere%2C%20webtoon%20illustration%20style%2C%20soft%20pastel%20colors&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '日常',
    status: '连载中',
    rating: 8.9,
    views: 560000,
    description: '四个性格迥异的闺蜜在日常生活中发生的爆笑故事，从校园到职场，从恋爱到友谊，每一个小剧场都充满了温暖和欢笑。',
    chapters: 98,
    updatedAt: '2026-07-02',
    featured: false,
  },
  {
    id: 6,
    slug: 'gaoxiao-tiandi',
    title: '搞笑天地',
    author: '韩志成',
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20comedy%20manhwa%20cover%20with%20an%20exaggerated%20cartoon%20character%20making%20a%20silly%20face%2C%20bright%20colorful%20background%20with%20comic%20explosion%20effects%2C%20humorous%20webtoon%20style%2C%20vibrant%20orange%20and%20yellow%20palette&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '搞笑',
    status: '连载中',
    rating: 9.0,
    views: 890000,
    description: '一群无厘头的角色在奇奇怪怪的世界中发生的离谱日常，每一话都能让你笑到肚子疼。轻松减压的最佳选择！',
    chapters: 55,
    updatedAt: '2026-07-01',
    featured: false,
  },
  {
    id: 7,
    slug: 'xingkong-xia-de-yueding',
    title: '星空下的约定',
    author: '尹素拉',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20cover%20depicting%20a%20couple%20stargazing%20on%20a%20hilltop%20at%20night%2C%20glowing%20stars%20and%20milky%20way%20above%2C%20tender%20emotional%20atmosphere%2C%20soft%20blue%20and%20silver%20color%20scheme%2C%20webtoon%20art%20style&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '恋爱',
    status: '已完结',
    rating: 9.4,
    views: 1650000,
    description: '天文系学生与音乐学院学生在一个流星雨的夜晚相遇，从此命运的齿轮开始转动。唯美纯净的校园恋爱故事，治愈系代表作。',
    chapters: 72,
    updatedAt: '2026-05-20',
    featured: true,
  },
  {
    id: 8,
    slug: 'longzu-juexing',
    title: '龙族觉醒',
    author: '姜东元',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20fantasy%20manhwa%20cover%20with%20a%20dragon%20rising%20from%20volcanic%20mountains%2C%20a%20hero%20standing%20with%20a%20sword%20facing%20the%20dragon%2C%20intense%20fire%20and%20lava%20effects%2C%20dramatic%20lighting%2C%20webtoon%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '奇幻',
    status: '连载中',
    rating: 9.6,
    views: 1890000,
    description: '远古龙族在沉睡千年后苏醒，人类世界面临前所未有的危机。少年龙裔诺亚踏上寻找先祖遗迹的旅途，她体内的龙血正在觉醒。',
    chapters: 113,
    updatedAt: '2026-07-03',
    featured: true,
  },
  {
    id: 9,
    slug: 'ansha-zhe-lianmeng',
    title: '暗杀者联盟',
    author: '陈仁浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20action%20Korean%20manhwa%20cover%20with%20a%20masked%20assassin%20in%20black%20clothing%20crouching%20on%20a%20rooftop%2C%20city%20skyline%20at%20night%2C%20neon%20lights%20reflecting%2C%20cyberpunk%20aesthetic%2C%20webtoon%20style%2C%20cool%20blue%20and%20purple%20tones&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '动作',
    status: '连载中',
    rating: 9.2,
    views: 1320000,
    description: '在未来的暗杀者世界中，各大家族明争暗斗。新人暗杀者雷鸣凭借超凡的战斗天赋，一步步揭开联盟背后的腥风血雨。',
    chapters: 81,
    updatedAt: '2026-06-30',
    featured: false,
  },
  {
    id: 10,
    slug: 'meishi-hunjie',
    title: '美食魂界',
    author: '张美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20themed%20cover%20with%20a%20young%20female%20chef%20presenting%20a%20beautiful%20dish%20in%20a%20warm%20restaurant%20kitchen%2C%20magical%20sparkles%20around%20the%20food%2C%20cozy%20atmosphere%2C%20webtoon%20style%2C%20warm%20orange%20and%20gold%20tones&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '日常',
    status: '连载中',
    rating: 8.8,
    views: 670000,
    description: '料理天才少女穿越到异世界，用美食征服各路神仙妖怪。每一道菜背后都有一个温暖的故事，美食与冒险的完美结合。',
    chapters: 48,
    updatedAt: '2026-06-25',
    featured: false,
  },
  {
    id: 11,
    slug: 'yinying-fating',
    title: '阴影法庭',
    author: '吴瑞贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20legal%20thriller%20cover%20showing%20a%20lawyer%20standing%20in%20a%20dark%20courtroom%2C%20dramatic%20spotlight%2C%20gavel%20on%20the%20desk%2C%20tense%20atmosphere%2C%20webtoon%20style%2C%20dark%20green%20and%20gold%20accents&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '悬疑',
    status: '已完结',
    rating: 9.5,
    views: 1450000,
    description: '天才律师金秀贤接手一桩看似普通的谋杀案，却发现案件背后牵扯到整个司法系统的黑暗面。法庭上的每一个反转都令人窒息。',
    chapters: 98,
    updatedAt: '2026-04-10',
    featured: false,
  },
  {
    id: 12,
    slug: 'xiao-hua-xiao-hua',
    title: '校花笑花',
    author: '金泰熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20high%20school%20comedy%20manhwa%20cover%20with%20a%20beautiful%20female%20student%20making%20a%20funny%20expression%2C%20classroom%20background%20with%20other%20students%20laughing%2C%20bright%20and%20cheerful%2C%20webtoon%20art%20style%2C%20pink%20and%20mint%20colors&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '搞笑',
    status: '连载中',
    rating: 9.0,
    views: 1020000,
    description: '全校公认的女神私下里却是个超级搞笑女？当高冷人设崩塌之后，一系列令人捧腹的校园喜剧就此展开。',
    chapters: 67,
    updatedAt: '2026-07-02',
    featured: false,
  },
];

export const categories = [
  { id: 1, slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', count: 156 },
  { id: 2, slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', count: 134 },
  { id: 3, slug: 'dongzuo', name: '动作', icon: 'ri-sword-line', count: 98 },
  { id: 4, slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', count: 87 },
  { id: 5, slug: 'richang', name: '日常', icon: 'ri-sun-line', count: 112 },
  { id: 6, slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 73 },
];

export const faqs = [
  {
    question: '哈哈漫画网是完全免费的吗？',
    answer: '是的，哈哈漫画网上的所有韩国漫画内容均为免费在线观看，无需付费订阅。我们致力于为广大漫画爱好者提供便捷、优质的阅读体验。',
  },
  {
    question: '如何开始阅读漫画？',
    answer: '在首页或分类页面选择您感兴趣的漫画，点击进入详情页后即可开始下拉式阅读。我们的阅读器支持键盘和触屏操作，提供流畅的阅读体验。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '平台上的热门连载漫画通常每周更新1-2话，部分作品可能会根据韩国原作更新进度进行调整。您可以关注喜欢的作品，获取最新更新通知。',
  },
  {
    question: '支持在手机上阅读吗？',
    answer: '当然支持！哈哈漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备，无论您使用什么设备都能享受流畅的下拉式阅读体验。',
  },
  {
    question: '漫画画质如何？',
    answer: '所有漫画均为高清画质，支持放大缩小功能，确保每一个细节都清晰可见。我们坚持提供最优质的视觉体验。',
  },
];